import React from "react";

/* Ecosystem partner logos — real images when available, else stylized placeholder */
const items = [
  { name: "Téléservice INSi",  img: "/logos/insi.png" },
  { name: "Mon espace santé",  img: "/logos/mon-espace-sante.png" },
  { name: "MSSanté",           img: "/logos/mssante.png" },
  { name: "DMP",               img: "/logos/dmp.png" },
  { name: "Certification HDS", img: "/logos/hds.png" },
  { name: "e-CPS",             img: "/logos/ecps.png" },
  { name: "TLSi",              img: "/logos/tlsi.png" },
  { name: "Amelipro Connect",  img: "/logos/amelipro.png" },
  { name: "Pro Santé Connect", img: "/logos/psc.png" },
];

export default function EcosystemLogos() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="eco-logos">
      {items.map((it) => {
        const slug = (it.short || it.name).toLowerCase().replace(/\s+/g, "-").replace(/é|è|ê/g, "e");
        return (
          <div
            key={it.name}
            className="logo-tile flex flex-col items-center justify-center text-center gap-2 py-4 px-2 min-h-[96px]"
            data-testid={`logo-${slug}`}
            title={it.name}
          >
            {it.img ? (
              <span className="grid place-items-center h-12 w-12 rounded-md bg-white p-1.5 overflow-hidden">
                <img
                  src={it.img}
                  alt={it.name}
                  className="max-h-full max-w-full object-contain"
                  loading="lazy"
                />
              </span>
            ) : (
              <span className="grid place-items-center h-12 w-12 rounded-md bg-[rgba(45,123,255,0.12)] border border-[rgba(127,179,255,0.25)] text-[12px] font-semibold text-[#0F2B5B] font-display">
                {it.short}
              </span>
            )}
            <span className="text-[11.5px] leading-tight text-[#0284C7] line-clamp-2">
              {it.name}
            </span>
          </div>
        );
      })}
    </div>
  );
}
